"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletApprove = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const constants_1 = require("../../helper/constants");
const ai_1 = require("react-icons/ai");
const ApprovalActions = __importStar(require("./redux/WalletApproverWrapperActions"));
// import * as SocketActions from "../socket-wrapper/redux/socketWrapperActions";
const WalletApprove = ({ WalletApproverView, WalletApproverViewProps }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const [counter, setCounter] = (0, react_1.useState)(1);
    const [accountDetails, setAccountDetails] = (0, react_1.useState)({});
    const { userProfile, fromInfo, authToken } = (0, react_redux_1.useSelector)((state) => state.walletApplicationWrapper);
    const { transactionId, 
    // approvals,
    status, isCheckingApproval, isApproving, isApproved, } = (0, react_redux_1.useSelector)((state) => state.walletApprovalWrapper);
    const { networkClient } = (0, react_redux_1.useSelector)((state) => state.walletConnector);
    (0, react_1.useEffect)(() => {
        // console.log("counter and transcation id value", counter, transactionId);
        if (counter && transactionId) {
            // dispatch(
            //   SocketActions.transactionAdded({
            //     id: transactionId,
            //     userId: userProfile.userId,
            //     event: "approval",
            //   })
            // );
            // console.log("about to fire checkBlockForTransaction");
            checkBlockForTransaction();
        }
        // eslint-disable-next-line
    }, [counter, transactionId]);
    (0, react_1.useEffect)(() => {
        if (userProfile && userProfile.accountGroups && fromInfo) {
            userProfile.accountGroups.forEach((group) => {
                group.addresses.forEach((item) => {
                    if (item.address.toUpperCase() === userProfile.userId.toUpperCase()) {
                        setAccountDetails(item);
                    }
                });
            });
        }
    }, [userProfile, fromInfo]);
    (0, react_1.useEffect)(() => {
        var _a;
        // console.log("0");
        // console.log(accountDetails?.address);
        // console.log(accountDetails?.network);
        // console.log(fromInfo?.token?.currency);
        if ((accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.address) && (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.network) && ((_a = fromInfo === null || fromInfo === void 0 ? void 0 : fromInfo.token) === null || _a === void 0 ? void 0 : _a.currency)) {
            // console.log("1");
            const contractAddress = constants_1.BRIDGE_CONTRACTS[accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.network];
            if (contractAddress) {
                // console.log("2");
                // console.log("checking approval for ", {
                //   address: accountDetails.address,
                //   contractAddress: contractAddress,
                //   currency: fromInfo.token.currency,
                // });
                dispatch(ApprovalActions.getApproval(accountDetails.address, contractAddress, fromInfo.token.currency));
            }
        }
        // eslint-disable-next-line
    }, [fromInfo, accountDetails, status]);
    // console.log(fromInfo);
    const checkBlockForTransaction = () => __awaiter(void 0, void 0, void 0, function* () {
        // console.log("checking chain for transaction");
        if (transactionId) {
            try {
                const transaction = yield (networkClient === null || networkClient === void 0 ? void 0 : networkClient.eth.getTransaction(transactionId));
                // console.log("Checking the transloota ", transaction);
                if (transaction && transaction.blockNumber) {
                    // console.log("Translo iso componte ", transaction);
                    dispatch(ApprovalActions.approvalFound());
                    //dipatch here that wallet is approved;
                }
                else {
                    // console.log("transction not found on block wait 3000ms and try again");
                    yield delay(3000);
                    // console.log("current counter value : ", counter);
                    if (counter === undefined) {
                        // console.log("counter was undefined set it to 1");
                        setCounter(1);
                    }
                    else {
                        // console.log("current counter value : ", counter);
                        // console.log("updating counter  value by 1");
                        setCounter(counter + 1);
                    }
                }
            }
            catch (ex) {
                setCounter(undefined);
                // console.log("Error while looking up transaction on block", ex);
                dispatch(ApprovalActions.approvalFailed());
                //dispatch here that approval is failed
            }
        }
    });
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    // console.log(approvals);
    const doApprove = () => {
        var _a;
        // console.log(isCheckingApproval, isApproved, isApproving);
        if (!isCheckingApproval && !isApproving && !isApproved) {
            if ((accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.address) && ((_a = fromInfo === null || fromInfo === void 0 ? void 0 : fromInfo.token) === null || _a === void 0 ? void 0 : _a.currency) && networkClient) {
                const contractAddress = constants_1.BRIDGE_CONTRACTS[accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.network];
                // console.log("About to perform approval for ", {
                //   address: accountDetails.address,
                //   contractAddress: contractAddress,
                //   currency: fromInfo.token.currency,
                //   authToken: authToken,
                //   networkClient: networkClient,
                // });
                if (contractAddress) {
                    dispatch(ApprovalActions.doApproval(accountDetails.address, contractAddress, fromInfo.token.currency, authToken, networkClient));
                }
            }
        }
    };
    // console.log("counter value logged : ", counter);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(WalletApproverView, Object.assign({ prefix: isApproving || isCheckingApproval ? react_1.default.createElement(ai_1.AiOutlineLoading3Quarters, null) : undefined, title: isCheckingApproval ? "Checking Approval..." : isApproving ? "Approving..." : "Approve", disabled: isCheckingApproval || isApproved || isApproving }, WalletApproverViewProps, { onClick: () => doApprove() }))));
};
exports.WalletApprove = WalletApprove;
//# sourceMappingURL=WalletApprove.js.map